var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownVectorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5858 16.0052L5.9792 7.39859L7.3934 5.98438L16 14.591L16 7.0052L18 7.0052L18 18.0052L7 18.0052L7 16.0052L14.5858 16.0052Z",
    fill: "#008E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownVectorGreen);
export default __webpack_public_path__ + "static/media/down-vector-green.b4eacf2d1609143fd7177af795324014.svg";
export { ForwardRef as ReactComponent };